<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E1RcKg/tc-custom/9781488041846.jpg?1728726639554" alt="This image is the cover for the book Anything for His Baby, Crimson, Colorado"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anything for His Baby, Crimson, Colorado
      </h1>
      <p class="bookDescription body article font2">
        <b>Love isn’t supposed to be part of the deal in this captivating small-town romance from the <i>USA Today</i>–bestselling author of <i>Coming Home to Crimson</i>.</b><br/><br/>His daughter comes first . . .<br/><br/>Shep Bennett’s as smooth as they come . . . except when it comes to his new daughter. Paige Harper has the magic touch with the traumatized toddler, so she strikes a bargain. She’ll care for Rosie, if Shep will let her run the inn he bought out from under her family. But will Paige be able to keep her heart out of the deal?<br/><br/><b>“Major writes reliable grown-up romances, and Paige and Shep’s story is worth an afternoon’s time.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Major
      </h2>
      
      <p class="authorDescription body article">USA Today bestselling author Michelle Major loves stories of new beginnings, second chances and always a happily ever after. An avid hiker and avoider of housework, she lives in the shadow of the Rocky Mountains with her husband, two teenagers and a menagerie of spoiled furbabies. Connect with her at www.michellemajor.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c621578e